var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"border-radius":"15px"},attrs:{"src":require("@/assets/images/logo/logo.jpg"),"alt":"Curfox Logo","height":"35"}})}
var staticRenderFns = []

export { render, staticRenderFns }